import BasePage from "@LandingPage/Scripts/Pages/BasePage";
import LightBuilding from "@LandingPage/Scripts/Pages/LightBuilding";

let App: any = {
    instances: {},
    pages: {},
    routes: {},
    viewModels: {},
    resources: {}
};

App.pages.BasePage = BasePage;
App.pages.LightBuilding = LightBuilding;

(<any>window).App = App;